import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  generateReport(
    title: string,
    columns: { label: string; key: string }[],
    data: unknown[],
  ): Workbook {
    const book = new Workbook();
    const sheet = book.addWorksheet(title);

    sheet.columns = columns.map((column) => ({
      header: column.label,
      key: column.key,
      width: 14,
    }));

    const header = sheet.getRow(1);
    header.height = 30;
    header.font = { bold: true };
    header.alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true,
    };

    const rows = data.map((item) => {
      const row: Record<string, unknown> = {};
      columns.forEach((column) => {
        const keyParts = column.key.split('.');
        if (keyParts.length > 1) {
          let value = item as Record<string, unknown>;
          keyParts.forEach((part) => {
            value = (value?.[part] as Record<string, unknown>) ?? {};
          });
          row[column.key] = value;
        } else {
          row[column.key] = (item as Record<string, unknown>)[column.key];
        }
      });
      return row;
    });

    sheet.addRows(rows);
    return book;
  }
}
